import React from 'react';
import PropTypes from 'prop-types';

import Column from '@Theme/hellofinance/components/Column/Column';
import Container from '@Theme/hellofinance/components/Container/Container';
import Row from '@Theme/hellofinance/components/Row/Row';
import ArticleVerticalTile from '@Theme/hellofinance/components/ArticleVerticalTile/ArticleVerticalTile';
import PostsList
  from '@Theme/hellofinance/components/PostsList/PostsList';

import * as styles from './RecentPosts.module.scss';

const propTypes = {
  /**
   * Module heading
   */
  heading: PropTypes.string,

  /**
   * Articles as an array of objects - picture, heading, description, href, date and readingTime
   */
  articles: PropTypes.arrayOf(
    PropTypes.shape({
      picture: PropTypes.shape({
        src: PropTypes.string,
        alt: PropTypes.string
      }),
      heading: PropTypes.string,
      description: PropTypes.string,
      href: PropTypes.string,
      date: PropTypes.string,
      readingTime: PropTypes.string
    })
  ),

  /**
   * Posts as an array of objects - heading, date, href, datetime
   */
  posts: PropTypes.arrayOf(
    PropTypes.shape({
      heading: PropTypes.string,
      date: PropTypes.string,
      href: PropTypes.string,
      datetime: PropTypes.string
    })
  ),

  /**
   * Color variant
   */
  variant: PropTypes.oneOf([
    'LightGray'
  ])
};

const RecentPosts = ({
  heading,
  articles,
  variant,
  posts
}) => {
  if (!articles && !posts) {
    return false;
  }

  return <section className={`${styles.root} ${variant ? styles[`root${variant}`] : ''}`}>
    <Container>
      {heading && <div className={styles.rootHeading}>{heading}</div>}
      <Row classname={styles.rootRow}>
        {articles && <>
          {articles.map((item, index) => <Column
            xs={4}
            md={4}
            classname={styles.rootCol}
            key={index}>
            <ArticleVerticalTile {...item} />
          </Column>)}
        </>}
      </Row>
      <div className={styles.rootWrapper}>
        <PostsList items={posts} />
      </div>
    </Container>
  </section>;
};

RecentPosts.propTypes = propTypes;

export default RecentPosts;
